import { render } from "./MobilePos.vue?vue&type=template&id=32e10dff&scoped=true"
import script from "./MobilePos.vue?vue&type=script&lang=js"
export * from "./MobilePos.vue?vue&type=script&lang=js"

import "./MobilePos.vue?vue&type=style&index=0&id=32e10dff&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e10dff"]])

export default __exports__